import React from 'react';
import classNames from 'classnames/bind';
// TODO Заменить на компонент LINK из carnica, когда он будет готов
import { Link, useIsMobileDimension } from '@beef/ui-kit';
import { Stores } from "./types";
import styles from "./styles.pcss";
import { Android, IOS, pushTopEvAnalytics } from "../../../../../utils";
import { IMG_URLS } from "./constants";
import { platformTypes } from "../../../../../constants/analytics";
var cx = classNames.bind(styles);
export var StoresIcons = function StoresIcons(_ref) {
  var storeLinks = _ref.storeLinks;
  var isMobile = useIsMobileDimension();
  var handleSendAnalytics = function handleSendAnalytics(platform) {
    pushTopEvAnalytics({
      action: 'click',
      item_type: 'icon',
      icon_name: platform,
      popup_title: 'выберите способ входа'
    });
  };
  return /*#__PURE__*/React.createElement("div", {
    className: cx('stores'),
    "data-t-id": "components-StoresIcons"
  }, /*#__PURE__*/React.createElement(IOS, null, isMobile && storeLinks[Stores.IOS] ? /*#__PURE__*/React.createElement(Link, {
    className: cx('stores__icon-full-width'),
    href: storeLinks[Stores.IOS]
  }, /*#__PURE__*/React.createElement("img", {
    alt: "",
    className: cx(''),
    src: IMG_URLS.IOS_FULL,
    "data-t-id": "components-StoresIcons"
  })) : storeLinks[Stores.IOS] && /*#__PURE__*/React.createElement(Link, {
    "aria-label": Stores.IOS,
    className: cx('stores__icon'),
    href: storeLinks[Stores.IOS],
    onClick: function onClick() {
      return handleSendAnalytics(platformTypes.appStore);
    }
  }, /*#__PURE__*/React.createElement("img", {
    alt: "",
    className: cx('stores__image', 'stores__ios-adapt'),
    src: IMG_URLS.IOS,
    "data-t-id": "components-StoresIcons"
  }))), /*#__PURE__*/React.createElement(Android, null, storeLinks[Stores.Android] && /*#__PURE__*/React.createElement(Link, {
    "aria-label": Stores.Android,
    className: cx('stores__icon'),
    href: storeLinks[Stores.Android],
    onClick: function onClick() {
      return handleSendAnalytics(platformTypes.playMarket);
    }
  }, /*#__PURE__*/React.createElement("img", {
    alt: "",
    className: cx('stores__image', 'stores__android-adapt'),
    src: IMG_URLS.ANDROID,
    "data-t-id": "components-StoresIcons"
  }))), /*#__PURE__*/React.createElement(Android, null, storeLinks[Stores.Huawei] && /*#__PURE__*/React.createElement(Link, {
    "aria-label": Stores.Huawei,
    className: cx('stores__icon'),
    href: storeLinks[Stores.Huawei],
    onClick: function onClick() {
      return handleSendAnalytics(platformTypes.huaweiStore);
    }
  }, /*#__PURE__*/React.createElement("img", {
    alt: "",
    className: cx('stores__image'),
    src: IMG_URLS.HUAWEI,
    "data-t-id": "components-StoresIcons"
  }))), /*#__PURE__*/React.createElement(Android, null, storeLinks[Stores.RuStore] && /*#__PURE__*/React.createElement(Link, {
    "aria-label": Stores.RuStore,
    className: cx('stores__icon'),
    href: storeLinks[Stores.RuStore],
    onClick: function onClick() {
      return handleSendAnalytics(platformTypes.ruStore);
    }
  }, /*#__PURE__*/React.createElement("img", {
    alt: "",
    className: cx('stores__image'),
    src: IMG_URLS.RU_STORE,
    "data-t-id": "components-StoresIcons"
  }))));
};